import { render, staticRenderFns } from "./TMCReport.vue?vue&type=template&id=1ec5c750&"
import script from "./TMCReport.vue?vue&type=script&lang=js&"
export * from "./TMCReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports